/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  export class MeevoCoOptionsSection implements angular.IDirective {
    restrict = "E";
    scope = {
        contextData: "=",
        hideButton: "=?"
    };

    templateUrl = "app/components/controls/coOptionsSectionTemplate.html";

    static factory(): angular.IDirectiveFactory {
      let directive = () => {
        return new MeevoCoOptionsSection();
      };

      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoCoOptionsSection", MeevoCoOptionsSection.factory());
}